import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const orderServices = {
    getAllOrders,
    getOrder,
    createOrder,
};

const MODULE = {
    ORDER: 'orders',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllOrders(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_locked: filter.isLocked,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.ORDER}`, requestOptions)
}

export function getOrder(id) {
    return apiHelper(API_URL).get(`/${MODULE.ORDER}/${id}`)
}

export function createOrder(data) {
    const requestOptions = {
        is_report_included: data.isReportIncluded,
        customer_vehicle_uuid: data.vehicleID,
        customer_uuid: data.customerID,
        report_uuid: data.reportID,
        remark: data.remark,
        receipt_send_to: data.receiptSendTo,
        total_amount: data.totalAmount,
        subtotal_amount: data.subTotalAmount,
        tax_amount: data.taxAmount,
        discount_amount: data.discountAmount,
        discount_method: data.discountMethod,
        diccount_value: data.discountValue, // Make sure this should be "discount_value"
        discount_percentages: data.discountPercentages,
        payment_method_uuid: data.paymentMethodID,
        payment_reference_number: data.paymentReferenceNumber,
        address_1: data.address1,
        address_2: data.address2,
        address_3: data.address3,
        postcode: data.postcode,
        city: data.city,
        state: data.state,
        params: {} // Initialize the params object here
    }
    
    let packages = [];
    let services = [];
    
    data.summaries.forEach((summary) => {
        if (summary.service != null) {
            services.push({ uuid: summary.service.uuid, quantity: summary.quantity });
        } else {
            packages.push({ uuid: summary.package.uuid, quantity: summary.package.quantity });
        }
    });
    
    requestOptions.packages = packages;
    requestOptions.services = services;
    
    
    return apiHelper(API_URL).post(`/${MODULE.ORDER}`, requestOptions);
    
}